/* src/app/components/enrollment/enrollment-list_old/enrollment-list.component.css */
/*# sourceMappingURL=enrollment-list.component-EYGTYLDV.css.map */
